import { render, staticRenderFns } from "./TabelaPropostasSelecionadas.vue?vue&type=template&id=08a57960"
import script from "./TabelaPropostasSelecionadas.vue?vue&type=script&lang=js"
export * from "./TabelaPropostasSelecionadas.vue?vue&type=script&lang=js"
import style0 from "./TabelaPropostasSelecionadas.vue?vue&type=style&index=0&id=08a57960&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports